import {useState} from 'react';
import {Link,NavLink} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const logoUrl='https://media-manager-c.questera.ai/greta-media/46a9e1323b5c997de8c3ebac6eb3f9d74ccd00e463a5744676fe05afae233bf74d2b422fbe3649d2b4b7a9fc91fa3904/images/aW1hZ2UvcG5n/ebec687f95708113e2801c74375cccae.png';

const navItems=[
  ['About','/about'],
  ['Ecosystem','/ecosystem'],
  ['Ventures','/ventures'],
  ['Partnerships','/partnerships'],
  ['Innovation','/innovation']
];

export default function Header() {
  const [open,setOpen]=useState(false);
  const closeMenu=()=>setOpen(false);

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link
          to="/"
          className="brand brand-logo"
          aria-label="ProfitYo Global home"
          onClick={closeMenu}
        >
          <img src={logoUrl} alt="ProfitYo Global" />
        </Link>

        <button
          className="menu-button"
          onClick={()=>setOpen(value=>!value)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <SafeIcon icon={open ? FiIcons.FiX : FiIcons.FiMenu} />
        </button>

        <nav className={`main-nav ${open ? 'is-open' : ''}`}>
          {navItems.map(([label,path])=>(
            <NavLink
              key={path}
              to={path}
              end={path==='/about'}
              onClick={closeMenu}
            >
              {label}
            </NavLink>
          ))}
          <Link to="/contact" className="nav-cta" onClick={closeMenu}>
            Contact us
            <SafeIcon icon={FiIcons.FiArrowUpRight} />
          </Link>
        </nav>
      </div>
    </header>
  );
}